import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cashConverter, formatPathDoc, formatText } from "../../../../utils";
import IspPayAddModal from "./modal/IspPayAddModal";
import useModalToggle from "../../../../custom_hooks/useModalToggle";
import svg12 from "../../../../assets/svg/svg12.svg";
import svg63 from "../../../../assets/svg/svg63.svg";
import IspPayCard from "./IspPayCard";
import { fetchData, fetchFiles } from "../../../../features/fetch/fetchSlice";
import moment from "moment";
import { Table } from "antd";
import ConfirmModal from "../../../../components/ConfirmModal";
import CardLoading from "../../../../components/CardLoading";

function IspPayTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "api/v2/payments/getPaymentsHistory";
  const urlPaymentType = "api/v2/paymentTypes/get";
  const { loading, data, count, activeObjexpressions,activeObjexpIsp } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      count: state.fetch.count[url] || 0,
      activeObjexpressions: state.obj.activeObj["expressions"],
      activeObjexpIsp: state.obj.activeObj["expressionIsp"],
    })
  );
 

  const [prodd, setProdd] = useState("");

  const { open, handleCancel, handleOpen } = useModalToggle();

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };
  const handleDelete = () => {};

  const handleEdit = async (item) => {
    await setProdd(item);
    await handleOpen();
  };

  const handleAdd = async () => {
    await setProdd("");
    await handleOpen();
  };

  const downloadFile = async (item) => {
    try {
      const res = await dispatch(fetchFiles({ file: item?.paymentFileUrl }));
      if (res?.payload) {
        window.open(res.payload, "_blank");
      }
    } catch (error) {
      console.error("Failed to open file:", error);
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Payment Date",
      dataIndex: "paymentDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.paymentDate).valueOf() - moment(b.paymentDate).valueOf(),
    },
    {
      title: "Paid By",
      dataIndex: "paymentPayerName",
      sorter: (a, b) => a.paymentPayerName.localeCompare(b.paymentPayerName),
    },
    {
      title: "Amount (Kes)",
      dataIndex: "paymentAmount",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.paymentAmount.localeCompare(b.paymentAmount),
    },
    {
      title: "Via",
      dataIndex: "paymentType",
      sorter: (a, b) => a.paymentType.localeCompare(b.paymentType),
    },
    {
      title: "Receipt",
      dataIndex: "paymentCode",
      sorter: (a, b) => a.paymentCode.localeCompare(b.paymentCode),
    },
    {
      title: "File",
      render: (item) => {
        return (
          <div
            className="cursor-pointer text-darkBlue"
            onClick={() => downloadFile(item)}
          >
            {formatPathDoc(item?.paymentFileUrl)}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "paymentStatus",
      render: (item) => {
        const colors = {
          CONFIRMED: "#B1E17C",
          NOT_CONFIRMED: "#E5E7E9",
        };

        return (
          <div
            className={`${
              item === "NOT_CONFIRMED" ? "text-black" : "text-[#FFF]"
            }  inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]`}
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },
    {
      title: "Actions",
      render: (item) => (
        <>
          <button onClick={() => handleEdit(item)}>
            <img src={svg12} alt="svg12" />
          </button>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        paymentProjectId: activeObjexpressions?.projectId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
    dispatch(
      fetchData({
        url: urlPaymentType,
        limit: null,
        start: 0,
      })
    );
  }, []);

  if (loading) return <CardLoading />;
  return (
    <div className="white_card mt-[1.25rem]">
      <div className="flex lg:flex-row flex-col gap-[1.25rem] lg:items-center justify-between">
        <div className="form-add-h !text-[1rem]">
       { activeObjexpIsp?.microIrrigationPartnerName}  Disbursment History
        </div>

        <div className="flex lg:flex-row flex-col lg:items-center gap-[.62rem]">
          <div className="w-[200px]">
            <button onClick={() => handleAdd()} className="cstm-btn-2">
              <span className="">Add Payment Record</span>
            </button>
          </div>
         
        </div>
      </div>
      <IspPayCard />

      <Table
        rowSelection={false}
        className="mt-[1.25rem] w-full"
        scroll={{
          x: 1200,
        }}
        rowKey={(record) => record?.paymentId}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          position: ["bottomRight"],
          current: pageIndex + 1,
          total: count,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPageIndex(page - 1);
            setPageSize(size);
            fetchTableData(page - 1, size);
          },
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
      />

      <IspPayAddModal
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="info"
        btnTitle="Push"
      />
    </div>
  );
}

export default IspPayTable;
